module.exports = __webpack_public_path__ + "static/media/folder.e76f33e4.svg";